import { render, staticRenderFns } from "./TeacherAssessment.vue?vue&type=template&id=2d8cc30d&scoped=true"
import script from "./TeacherAssessment.vue?vue&type=script&lang=js"
export * from "./TeacherAssessment.vue?vue&type=script&lang=js"
import style0 from "./TeacherAssessment.vue?vue&type=style&index=0&id=2d8cc30d&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8cc30d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d8cc30d')) {
      api.createRecord('2d8cc30d', component.options)
    } else {
      api.reload('2d8cc30d', component.options)
    }
    module.hot.accept("./TeacherAssessment.vue?vue&type=template&id=2d8cc30d&scoped=true", function () {
      api.rerender('2d8cc30d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/MindAssessment/components/TeacherAssessment.vue"
export default component.exports